var map = {
	"./accepted.svg": "a6f4",
	"./billCompleted.svg": "6751",
	"./blueWallet.svg": "7dd2",
	"./cancelled.svg": "b5c4",
	"./completed.svg": "c054",
	"./init.svg": "9f92",
	"./neworder.png": "eab9",
	"./neworder.svg": "83d9",
	"./ondelivery.svg": "c161b",
	"./open.svg": "ac99",
	"./prepared.svg": "52dd",
	"./preparing.svg": "b098",
	"./readtopickup.svg": "0468",
	"./search.svg": "9dda",
	"./stopWatch.svg": "d2be",
	"./submitted.svg": "dc22",
	"./transformed.svg": "c922"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "efc4";